import styled from 'styled-components';

import colors from 'utils/colors';
import device from 'utils/device';

export const Wrapper = styled.a`
  display: flex;
  align-self: center;
  text-decoration: none;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  padding: 0.6rem 1rem;
  background-color: ${colors.orange};
  border-color: ${colors.orange};

  :hover,
  :focus {
    background-color: ${colors.brown};
    border-color: ${colors.brown};
  }

  @media ${device.isDesktop} {
  }
`;

export const Text = styled.div`
  font-family: VIC;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: -0.32px;
  color: ${colors.white};

  @media ${device.isDesktop} {
  }
`;

export const IconWrapper = styled.div`
  margin-left: 8px;
  svg {
    width: 15px;
    height: 15px;
    box-sizing: content-box;
    path {
      fill: ${colors.white};
    }

    &:before,
    &:after {
      box-sizing: content-box;
    }
  }
`;

export const UserIconWrapper = styled(IconWrapper)``;
